function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMNew = function SvgMNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "50%",
    height: "50%",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 145 135"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.38 134.812V.188h47.118l23.271 117.315h3.462L97.502.188h47.118v134.624h-24.617V18.843h-3.462L93.463 134.812H51.537L28.459 18.843h-3.462v115.969z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgMNew;